export default __webpack_public_path__ + "static/media/Believer's Hood of the Eldritch.bb47adb8.jpg";